<div class="social-icons" *ngIf="socialIcons">
  <ul>
    <li *ngFor="let icon of socialIcons">
      <a [target]="'blank'" [href]="icon.url">
        <img [src]="getIconUrl(icon)" [alt]="icon.icon">
      </a>
    </li>
  </ul>
</div>
